'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/uri.js
// module id = 2052
// module chunks = 41